module.exports = __webpack_public_path__ + "img/brandingMob.126cc554.jpg";